<template>
  <div v-if="isLoading" class="fixed inset-0 flex items-center justify-center bg-gray-800 bg-opacity-50 z-50 dark:bg-dark-bg">
    <div class="loader"></div>
  </div>
</template>

<script>
import AppStore from '@/store/app';

export default {
  computed: {
    isLoading() {
      return !!AppStore?.isLoading;
    }
  }
};
</script>

<style>
.loader {
  border: 16px solid #f3f3f3; /* Light grey */
  border-top: 16px solid rgb(126 73 233); /* Blue */
  border-radius: 50%;
  width: 120px;
  height: 120px;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
